module.exports = __webpack_public_path__ + "static/media/comment-alt-slash.7fd630d2.svg";